namespace Roodik.Game
{
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	
	export class TileModel implements ITileModel
	{
		description : string;
		private _nScale : number = 1;
		private _tileWidth : number = 120;
		private _tileWidthHalf : number = 60;
		private _tileHeight : number = 120;
		private _tileHeightHalf : number = 60;
		private _x : number;
		private _y : number;
		private _scaleX : number = 1;
		private _scaleY : number = 1;
		private _indexX : number;
		private _indexY : number;
		private _indexZ : number;
		private _selected : boolean = false;
		private _removed : boolean = false;
		private _illegalAnimation : boolean = false;
		private _animationShowing : boolean = false;
		private _type : string;
		private _sound : string;
		private _highlighted : boolean;
		private _removeTween:Tween;
		
		constructor(private _index : number,
		            private _key : string,
		            private _startPositions : IStartPosition,
		            tileInfo : ITileInfo)
		{
			this._type = tileInfo.type;
			this._sound = tileInfo.sound;
			
			this.parseIndexAxis();
		}
		
		private parseIndexAxis()
		{
			let arr = this._key.split(":");
			this._indexX = +arr[0];
			this._indexY = +arr[1];
			this._indexZ = +arr[2];
		}
		
		public changeTileInfo(type : string, sound:string)
		{
			this._type = type;
			this._sound = sound;

			if (this._changeTypeCallBack != null)
			{
				this._changeTypeCallBack();
			}
		}
		
		public calculatePosition()
		{
			this._x = -this._tileWidthHalf;
			this._y = -this._tileHeightHalf;
			
			let moveRowByX = this._indexY * this._tileWidthHalf * 0.75;
			let moveRowByY = -this._indexY * this._tileHeightHalf * .7;
			let moveColumnByX = this._indexX * (this._tileWidth * .4);
			let moveColumnByY = this._indexX * (this._tileHeight * .2);
			let moveXTileCoordByZ = this._indexZ * 4;
			
			let nStartX = moveRowByX - moveColumnByX + this._startPositions.x;
			let nStartY = moveRowByY - moveColumnByY - this._startPositions.y;
			
			let nX : number = nStartX + this._indexX * this._tileWidth * this._nScale + this._tileWidthHalf;
			let nY : number = nStartY + this._indexY * this._tileHeight * this._nScale + this._tileHeightHalf;
			let nZ : number = this._indexZ * (this._tileHeight * .1 * 2) * this._nScale;
			
			this._x = Math.round(this._x + nX + ((nZ / (this._tileHeight * .1))) + moveXTileCoordByZ);
			this._y = Math.round(this._y + nY - nZ);
		}
		
		public showIllegalAnimation() : void
		{
			if(!this._animationShowing)
			{
				this._animationShowing = true;
				this._illegalAnimation = true;
				let originalX = this._x;
				
				let intervalId : number = setInterval(() =>
				{
					let point : PIXI.Point = new PIXI.Point();
					point.x = Math.floor(Math.random() * 7) - 3;
					
					this._x = originalX + point.x;
					this._changePositionCallBack();
					
				}, 50);
				
				let timeoutId : number = setTimeout(() =>
				{
					this._x = originalX;
					this._changePositionCallBack();
					this._animationShowing = false;
					this._illegalAnimation = false;
					clearInterval(intervalId);
					clearTimeout(timeoutId);
				}, 300);
			}
		}
		
		public highlight()
		{
			if(!this._animationShowing)
			{
				this._highlighted = true;
				
				this._animationShowing = true;
				let originalY = this._y;
				
				let intervalId : number = setInterval(() =>
				{
					let point : PIXI.Point = new PIXI.Point();
					point.y = Math.floor(Math.random() * 8);
					
					this._y = originalY + point.y;
					
				}, 100);
				
				let timeoutId : number = setTimeout(() =>
				{
					this._y = originalY;
					this._animationShowing = false;
					clearInterval(intervalId);
					clearTimeout(timeoutId);
				}, 500);
			}
		}
		
		public remove(removedCallBack : () => void)
		{
			this._removed = true;
			
			let obj = {
				x:1,
				y:1
			};

			this._removeTween = new Tween(obj)
			.to({
				x:0,
				y:0
			}, 150)
			.easing(Easing.Quartic.Out)
			.onUpdate(this.onUpdateRemoveAnimation.bind(this, obj))
			.onComplete(() =>
			{
				removedCallBack();
			})
			.start();
		}
		
		public undo(viewKey:string)
		{
			this.reset();
			
			this._removeTween.stop();
			this._removeTween = null;
		}
		
		public reset()
		{
			this._highlighted = false;
			this._removed = false;
		}
		
		private onUpdateRemoveAnimation(obj : any) : void
		{
			this._scaleX = obj.x;
			this._scaleY = obj.y;
			
			this._changePositionCallBack();
		}
		
		public get highlighted() : boolean {return this._highlighted;}
		
		public get removed() : boolean {return this._removed;}
		
		public get type() : string {return this._type;}
		
		public get sound() : string {return this._sound;}
		
		public get indexX() : number { return this._indexX;}
		
		public get indexY() : number { return this._indexY;}
		
		public get indexZ() : number { return this._indexZ;}
		
		public get index() : number { return this._index;}
		
		public get key() : string { return this._key;}
		
		public get x() : number { return this._x;}
		
		public get y() : number { return this._y;}

		public get scaleX() : number { return this._scaleX;}

		public get scaleY() : number { return this._scaleY;}
		
		public get selected() : boolean { return this._selected;}
		
		public set selected(value : boolean)
		{
			this._selected = value;
			
			if (this._selectedCallBack)
			{
				this._selectedCallBack();
			}
		}
		
		private _selectedCallBack:()=>void;
		public selectedCallBack(callBack:()=>void)
		{
			this._selectedCallBack = callBack;
		}
		
		private _changePositionCallBack:()=>void;
		public changePositionCallBack(callBack:()=>void)
		{
			this._changePositionCallBack = callBack;
		}

		private _changeTypeCallBack:()=>void;
		public changeTypeCallBack(callBack:()=>void)
		{
			this._changeTypeCallBack = callBack;
		}
		
		public destroy()
		{
			this._selectedCallBack = null;
			this._changePositionCallBack = null;
			this._changeTypeCallBack = null;

			if (this._removeTween != null)
			{
				this._removeTween.stop();
				this._removeTween = null;
			}
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/Board/TileModel.ts